"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthContextValue = exports.useAuthContextProvider = void 0;
const types_1 = require("@src/types");
const react_1 = __importDefault(require("react"));
const Cookies = __importStar(require("js-cookie"));
const react_router_1 = require("react-router");
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const api_1 = require("@src/api");
const antd_1 = require("antd");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const react_intl_1 = require("react-intl");
const react_query_1 = require("react-query");
const queries_1 = require("@src/types/queries");
const socket_context_1 = require("./socket-context");
const account_context_1 = require("./account-context");
const AuthContext = react_1.default.createContext({
    isModalOpen: false,
    setIsModalOpen: () => { },
    checkAuthentication: () => { },
    authModalPromise: { resolve: () => { }, reject: () => { } },
    logout: async () => { },
});
const useAuthContextProvider = () => {
    const socket = (0, socket_context_1.useSocket)();
    const intl = (0, react_intl_1.useIntl)();
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const [isModalOpen, setIsModalOpen] = react_1.default.useState(false);
    const [authModalPromise, setAuthModalPromise] = react_1.default.useState({
        resolve: () => { },
        reject: () => { },
    });
    const account = (0, account_context_1.useAccount)();
    const location = (0, react_router_1.useLocation)();
    const history = (0, react_router_1.useHistory)();
    react_1.default.useEffect(() => {
        setIsModalOpen(false);
    }, [location]);
    const checkAuthentication = () => {
        if (account) {
            return Promise.resolve(account);
        }
        setIsModalOpen(true);
        return new Promise((resolve, reject) => {
            setAuthModalPromise({ resolve, reject });
        });
    };
    const logoutOptionsRef = react_1.default.useRef(undefined);
    const applyClientLogoutSideEffects = react_1.default.useCallback((options) => {
        var _a;
        if (typeof FB !== 'undefined') {
            FB === null || FB === void 0 ? void 0 : FB.logout();
        }
        Cookies.remove('connect.sid');
        Cookies.remove('pracujSocketCookieSession');
        SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
        queryClient.invalidateQueries(queries_1.Queries.getCompany);
        socket.emit(types_1.SocketEvents.ACCOUNT_LOG_OUT, account);
        if (!(options === null || options === void 0 ? void 0 : options.skipNotification)) {
            antd_1.notification.success({
                message: intl.formatMessage({ id: 'general.notice' }),
                description: intl.formatMessage({ id: 'logout.logged_out_successfully' }),
            });
        }
        history.pushLocalized((_a = options === null || options === void 0 ? void 0 : options.redirectTo) !== null && _a !== void 0 ? _a : '/');
    }, [SSRFetchClient, account, history, intl, queryClient, socket]);
    const { mutateAsync: mutateLogout } = (0, useAppMutation_1.useAppMutation)(api_1.Auth.logout, {
        onSuccess: () => {
            applyClientLogoutSideEffects(logoutOptionsRef.current);
            logoutOptionsRef.current = undefined;
        },
    });
    return {
        AuthContextProvider: AuthContext.Provider,
        value: {
            isModalOpen,
            setIsModalOpen,
            checkAuthentication,
            authModalPromise,
            logout: async (options) => {
                if (options === null || options === void 0 ? void 0 : options.clientOnly) {
                    applyClientLogoutSideEffects(options);
                    return;
                }
                logoutOptionsRef.current = options;
                await mutateLogout();
            },
        },
    };
};
exports.useAuthContextProvider = useAuthContextProvider;
const useAuthContextValue = () => {
    const context = react_1.default.useContext(AuthContext);
    return context;
};
exports.useAuthContextValue = useAuthContextValue;
